var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAreas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.985 .985)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.662,
    height: 5.415,
    fill: "#E3E3E3",
    rx: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37383A",
    d: "M14.951 8.123h4.395c.724 0 1.047.087 1.354.251.306.164.547.405.71.711.164.306.252.63.252 1.354v.784c0 .724-.088 1.047-.252 1.354a1.709 1.709 0 0 1-.71.71c-.307.164-.63.251-1.354.251h-4.395c-.724 0-1.047-.087-1.353-.25a1.709 1.709 0 0 1-.711-.711c-.164-.307-.251-.63-.251-1.354v-.784c0-.725.087-1.048.251-1.354.164-.306.404-.547.71-.71.307-.165.63-.252 1.354-.252zm-12.636 0H6.71c.724 0 1.047.087 1.354.251.306.164.547.405.71.711.164.306.252.63.252 1.354v.784c0 .724-.088 1.047-.252 1.354a1.709 1.709 0 0 1-.71.71c-.307.164-.63.251-1.354.251H2.315c-.724 0-1.047-.087-1.353-.25a1.709 1.709 0 0 1-.71-.711C.086 12.27 0 11.947 0 11.223v-.784c0-.725.087-1.048.251-1.354.164-.306.405-.547.71-.71.307-.165.63-.252 1.354-.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M2.708 21.662a2.708 2.708 0 1 1 0-5.416 2.708 2.708 0 0 1 0 5.416zm16.246 0a2.708 2.708 0 1 1 0-5.416 2.708 2.708 0 0 1 0 5.416zm-8.123 0a2.708 2.708 0 1 1 0-5.416 2.708 2.708 0 0 1 0 5.416z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreas);
export default __webpack_public_path__ + "static/media/ic-areas.d51a41343a609cc2c15f6dea4399a4b7.svg";
export { ForwardRef as ReactComponent };